export enum RegisterActionType {
  Customer,
  Business,
  BusinessAddress,
  BusinessAddressByZipcode,
  BusinessLicense,
  Configuration,
  Characteristics,
  Reset,
}
